import { isAvailable } from "@Pages/Search/components/SearchListItem/helper";
import checkIsFlexibleMoveIn from "./checkIsFlexibleMoveIn";

const getMoveIn = (accommodationDetails: any, inventoryData: any) => {
  const availableRooms = inventoryData?.active_children?.filter((config: any) =>
    isAvailable(config),
  );
  const isFlexibleMoveIn = checkIsFlexibleMoveIn(accommodationDetails, availableRooms);

  const getArrivalDateFormatted = () => {
    if (!accommodationDetails?.arrival_date) return "";
    const date = new Date(accommodationDetails?.arrival_date);
    return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  };

  if (isFlexibleMoveIn) return getArrivalDateFormatted();
  return (
    getArrivalDateFormatted() ||
    availableRooms
      ?.find((r: any) => +r.id === +accommodationDetails?.roomType)
      ?.active_children?.find(
        (t: any) =>
          +t.id === +(accommodationDetails?.tenancyId || accommodationDetails?.inventory_id),
      )?.meta?.available_from_formatted
  );
};

export default getMoveIn;
